import React, { useState } from 'react';
import Carousel from './Carousel';
import ProjectModal from './ProjectModal';
import WorkProjectModal from './WorkProjectModal';
import './Project.css';

const projects = [
  { 
    title: 'Collaborative Task Management System', 
    description: 'A task management system that allows users to create, assign, and track tasks collaboratively.',
    url: 'https://taskifyflow.com'
  },
  { 
    title: 'AI Email Assistant', 
    description: 'An AI-powered email assistant that uses natural language processing + API keys to help users manage their email.',
    url: 'https://emailifyai.com'
  },
  { title: '3D Explorer Game (In Progress)', description: '3D explorer game built with Three.js and WebGL, allowing users to navigate a 3D world and interact with objects.' },
  {
    title: 'The Project Hub',
    description: 'Internal company application I am building at my current job to centralize project workflows, visibility, and team coordination.',
    image: 'TPHworkimg.png',
    imagePath: 'Projectimg',
    isWorkProject: true
  },
  { title: 'In depth Galaxy explorer game (Planning Stage)', description: 'A 3D web-app game that allows users to explore galaxies and clusters and be able to learn about them, dynamically generated.' },
];

const Project = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isWorkModalOpen, setIsWorkModalOpen] = useState(false);

  const handleProjectClick = (project) => {
    if (project.isWorkProject) {
      setIsWorkModalOpen(true);
    } else if (project.url) {
      window.open(project.url, '_blank');
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <div className="project-container">
      <h2 className="project-title">My Projects</h2>
      <Carousel projects={projects} onProjectClick={handleProjectClick} />
      <ProjectModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <WorkProjectModal isOpen={isWorkModalOpen} onClose={() => setIsWorkModalOpen(false)} />
    </div>
  );
};

export default Project;
